module.exports = __webpack_public_path__ + "img/south_africa.63207244.svg";